import { useSelector } from "react-redux";

import MalwareChart from "../../../Components/common/MalwareChart/MalwareChart";
import Stats from "./Stats";

import CleanSubmissionsIcon from "../../../Components/Icon-SVG/CleanSubmissionsIcon";
import MaliciousSubmissionsIcon from "../../../Components/Icon-SVG/MaliciousSubmissionsIcon";

const calculatePrct = (count, totalCount) => (count > 0 ? (count / totalCount) * 100 : 0);

const Distribution = () => {
  const list = useSelector((state) => state.phishBox.phishBoxList);

  const allowedCount = list.filter((el) => el.decision === "allowed").length;
  const notAllowedCount = list.filter((el) => el.decision === "notallowed").length;
  const totalCount = allowedCount + notAllowedCount;

  const allowedPrct = calculatePrct(allowedCount, totalCount);
  const notAllowedPrct = calculatePrct(notAllowedCount, totalCount);

  const visitedCount = list.filter((el) => el.visited === true).length;
  const visitedPrct = calculatePrct(visitedCount, totalCount);

  const viewedCount = list.filter((el) => el.description.includes("viewed")).length;
  const viewedPrct = calculatePrct(viewedCount, totalCount);

  return (
    <>
      <div className="phishbox__distribution border">
        <MalwareChart
          chartIcon={<CleanSubmissionsIcon width={32} height={32} />}
          chartValue={allowedPrct?.toFixed(2)}
          chartName="Allowed Submissions"
          chartColor="#28c30f"
          chartCount={allowedCount}
        />
        <MalwareChart
          chartIcon={<MaliciousSubmissionsIcon width={32} height={32} />}
          chartValue={notAllowedPrct?.toFixed(2)}
          chartName="Not Allowed Submissions"
          chartColor="var(--network-blocks-sbox-border)"
          chartCount={notAllowedCount}
        />
      </div>
      <Stats
        items={[
          { displayName: "viewed", count: viewedCount, percentage: viewedPrct.toFixed(0) },
          { displayName: "visited", count: visitedCount, percentage: visitedPrct.toFixed(0) },
        ]}
      />
    </>
  );
};

export default Distribution;
